"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AxisRenderable = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ChartData = _interopRequireDefault(require("../../chartdata/ChartData"));

function DefaultAxisLine(props) {
  return _react.default.createElement("line", (0, _extends2.default)({
    stroke: "inherit"
  }, props.axisLineProps));
}

function DefaultTick(props) {
  return _react.default.createElement("line", (0, _extends2.default)({
    stroke: "inherit"
  }, props.tickLineProps));
}

function DefaultText(props) {
  return _react.default.createElement("text", (0, _extends2.default)({
    fontSize: 12,
    children: props.tick,
    stroke: "none"
  }, props.textProps));
}

var AxisRenderable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(AxisRenderable, _React$PureComponent);

  function AxisRenderable() {
    (0, _classCallCheck2.default)(this, AxisRenderable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AxisRenderable).apply(this, arguments));
  }

  (0, _createClass2.default)(AxisRenderable, [{
    key: "drawTicks",
    value: function drawTicks() {
      var _this = this;

      var _this$props = this.props,
          axisLineWidth = _this$props.axisLineWidth,
          Text = _this$props.text,
          TickLine = _this$props.tickLine,
          tickSize = _this$props.tickSize,
          textPadding = _this$props.textPadding,
          scale = _this$props.scale,
          position = _this$props.position;
      var offset = this.props.scale.bandwidth ? this.props.scale.bandwidth() / 2 : 0;
      return this.props.ticks(scale).map(function (tick, index) {
        var distance = scale(tick) + offset;

        var formattedTick = _this.props.textFormat(tick);

        var _this$getPointPositio = _this.getPointPosition(position, distance, axisLineWidth / 2),
            _this$getPointPositio2 = (0, _slicedToArray2.default)(_this$getPointPositio, 2),
            x1 = _this$getPointPositio2[0],
            y1 = _this$getPointPositio2[1];

        var _this$getPointPositio3 = _this.getPointPosition(position, distance, axisLineWidth / 2 + tickSize),
            _this$getPointPositio4 = (0, _slicedToArray2.default)(_this$getPointPositio3, 2),
            x2 = _this$getPointPositio4[0],
            y2 = _this$getPointPositio4[1];

        var _this$getPointPositio5 = _this.getPointPosition(position, distance, axisLineWidth / 2 + tickSize + textPadding),
            _this$getPointPositio6 = (0, _slicedToArray2.default)(_this$getPointPositio5, 2),
            textX = _this$getPointPositio6[0],
            textY = _this$getPointPositio6[1];

        var tickLineProps = {
          axisPosition: position,
          index: index,
          size: _this.props.tickSize,
          x: x1,
          y: y1,
          tickLineProps: (0, _objectSpread2.default)({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            strokeWidth: axisLineWidth
          }, _this.props.tickLineProps)
        };
        var textProps = {
          index: index,
          position: position,
          tick: formattedTick,
          x: textX,
          y: textY,
          textProps: (0, _objectSpread2.default)({
            x: textX,
            y: textY,
            textAnchor: _this.getTextAnchorProp(position),
            dominantBaseline: _this.getAlignmentBaselineProp(position)
          }, _this.props.textProps)
        };
        return _react.default.createElement("g", {
          key: tick
        }, _react.default.createElement(TickLine, tickLineProps), _react.default.createElement(Text, textProps));
      });
    }
  }, {
    key: "drawAxisLine",
    value: function drawAxisLine() {
      var _axisLineProps;

      var _this$props2 = this.props,
          AxisLine = _this$props2.axisLine,
          overlap = _this$props2.overlap,
          position = _this$props2.position,
          axisLineWidth = _this$props2.axisLineWidth;

      var _this$getPointPositio7 = this.getPointPosition(position, overlap * -1, 0),
          _this$getPointPositio8 = (0, _slicedToArray2.default)(_this$getPointPositio7, 2),
          x1 = _this$getPointPositio8[0],
          y1 = _this$getPointPositio8[1];

      var _this$getPointPositio9 = this.getPointPosition(position, this.props[this.getLengthProp(position)] + overlap, 0),
          _this$getPointPositio10 = (0, _slicedToArray2.default)(_this$getPointPositio9, 2),
          x2 = _this$getPointPositio10[0],
          y2 = _this$getPointPositio10[1];

      var axisLineProps = (_axisLineProps = {
        x: x1,
        y: y1
      }, (0, _defineProperty2.default)(_axisLineProps, this.getLengthProp(position), this.props[this.getLengthProp(position)]), (0, _defineProperty2.default)(_axisLineProps, "axisLineProps", (0, _objectSpread2.default)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        strokeWidth: axisLineWidth
      }, this.props.axisLineProps)), _axisLineProps);
      return _react.default.createElement(AxisLine, axisLineProps);
    }
  }, {
    key: "getAlignmentBaselineProp",
    value: function getAlignmentBaselineProp(position) {
      switch (position) {
        case 'left':
        case 'right':
          return 'middle';

        case 'top':
          return 'auto';

        case 'bottom':
          return 'hanging';

        default:
          throw new Error("unknown position: ".concat(position));
      }
    }
  }, {
    key: "getTextAnchorProp",
    value: function getTextAnchorProp(position) {
      switch (position) {
        case 'top':
        case 'bottom':
          return 'middle';

        case 'left':
          return 'end';

        case 'right':
          return 'start';

        default:
          throw new Error("unknown position: ".concat(position));
      }
    }
  }, {
    key: "getLengthProp",
    value: function getLengthProp(position) {
      return position === 'top' || position === 'bottom' ? 'width' : 'height';
    }
  }, {
    key: "getPointPosition",
    value: function getPointPosition(position, distance, offset) {
      var location = 0;
      var _this$props3 = this.props,
          yScale = _this$props3.yScale,
          xScale = _this$props3.xScale;

      if (this.props.location != undefined) {
        if (position === 'top' || position === 'bottom') {
          location = yScale(this.props.location);
        } else {
          location = xScale(this.props.location);
        }
      }

      switch (position) {
        case 'top':
          return [distance, location - offset];

        case 'bottom':
          location = location || this.props.height;
          return [distance, location + offset];

        case 'left':
          return [location - offset, this.props.height - distance];

        case 'right':
          location = location || this.props.width;
          return [location + offset, this.props.height - distance];

        default:
          throw new Error("unknown position: ".concat(position));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("g", null, _react.default.createElement("g", null, this.drawAxisLine()), _react.default.createElement("g", null, this.drawTicks()));
    }
  }]);
  return AxisRenderable;
}(_react.default.PureComponent);

exports.AxisRenderable = AxisRenderable;
(0, _defineProperty2.default)(AxisRenderable, "defaultProps", {
  axisLine: DefaultAxisLine,
  axisLineProps: {},
  axisLineWidth: 1,
  overlap: 0,
  text: DefaultText,
  textFormat: function textFormat(text) {
    return _ChartData.default.isValueDate(text) && typeof text.toISOString === 'function' ? text.toISOString().slice(0, 10) : text;
  },
  textPadding: 6,
  textProps: {},
  tickLine: DefaultTick,
  tickLineProps: {},
  ticks: function ticks(scale) {
    return scale.ticks ? scale.ticks() : scale.domain();
  },
  tickSize: 6
});
(0, _defineProperty2.default)(AxisRenderable, "propTypes", {
  position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
  location: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.instanceOf(Date)]),
  axisLine: _propTypes.default.func,
  axisLineProps: _propTypes.default.object,
  axisLineWidth: _propTypes.default.number,
  tickLine: _propTypes.default.func,
  tickLineProps: _propTypes.default.object,
  text: _propTypes.default.func,
  textProps: _propTypes.default.object,
  textFormat: _propTypes.default.func,
  tickSize: _propTypes.default.number,
  textPadding: _propTypes.default.number,
  overlap: _propTypes.default.number,
  scale: _propTypes.default.func.isRequired,
  xScale: _propTypes.default.func,
  yScale: _propTypes.default.func,
  ticks: _propTypes.default.func,
  width: _propTypes.default.number.isRequired,
  height: _propTypes.default.number.isRequired
});

var Axis =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Axis, _React$Component);

  function Axis() {
    (0, _classCallCheck2.default)(this, Axis);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Axis).apply(this, arguments));
  }

  (0, _createClass2.default)(Axis, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          dimension = _this$props4.dimension,
          position = _this$props4.position;
      var defaultPosition = dimension === 'x' ? 'bottom' : 'left';
      return _react.default.createElement(AxisRenderable, (0, _extends2.default)({}, this.props, {
        position: position || defaultPosition,
        scale: this.props["".concat(dimension, "Scale")]
      }));
    }
  }]);
  return Axis;
}(_react.default.Component);

exports.default = Axis;
(0, _defineProperty2.default)(Axis, "chartType", 'axis');
(0, _defineProperty2.default)(Axis, "propTypes", {
  dimension: _propTypes.default.string.isRequired,
  position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left'])
});